<template>
<div id="new-contract-01">
    <div class="container mt-4 pr-4 pl-4 pb-1">
        <h3 class="font-weight-normal mb-4">สร้างสัญญา</h3>
        <div class="row mb-4">
            <div class="col">
                <router-link class="card shadow" :to="{ name: 'new-contract-02', params: { type: 'money' } }">
                    <div class="card-body text-center text-dark p-4">
                        <img class="mb-2 icon-56" :src="$util.asset('goobank_assets/assets/icons/contract-money@2x.png')" />
                        <h3 class="font-weight-normal">สัญญาเงินกู้</h3>
                        <p class="m-0 text-secondary">สร้างสัญญาขอกู้เงินโดยกำหนดวงเงินและอัตราดอกเบี้ยด้วยตัวเอง</p>
                    </div>
                </router-link>
            </div>
        </div>
        <div class="row mb-4">
            <div class="col">
                <router-link class="card shadow" :to="{ name: 'new-contract-02', params: { type: 'thing' } }">
                    <div class="card-body text-center text-dark p-4">
                        <img class="mb-2 icon-56" :src="$util.asset('goobank_assets/assets/icons/contract-thing@2x.png')" />
                        <h3 class="font-weight-normal">สัญญาซื้อขาย</h3>
                        <p class="m-0 text-secondary">สร้างสัญญาขอกู้เงินโดยกำหนดวงเงินและอัตราดอกเบี้ยด้วยตัวเอง</p>
                    </div>
                </router-link>
            </div>
        </div>
        <div class="row mb-4">
            <div class="col">
                <router-link class="card shadow" :to="{ name: 'new-contract-02', params: { type: 'mortgage' } }">
                    <div class="card-body text-center text-dark p-4">
                        <img class="mb-2 icon-56" :src="$util.asset('goobank_assets/assets/icons/contract-thing@2x.png')" />
                        <h3 class="font-weight-normal">สัญญาสินเชื่อบ้าน</h3>
                        <p class="m-0 text-secondary">สร้างสัญญาสินเชื่อบ้านโดยกำหนดวงเงินและอัตราดอกเบี้ย</p>
                    </div>
                </router-link>
            </div>
        </div>
        <div class="row pt-4 pb-2">
            <div class="col"><a class="btn btn-light btn-lg btn-block" :href="$util.url('member/home')">ย้อนกลับ</a></div>
        </div>
    </div>
</div>
</template>

<script>
export default {
}
</script>

<style lang="scss">
</style>
